import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';


export const TAXONS_SET_ROOT_TAXON = 'TAXONS_SET_ROOT_TAXON';
export const TAXONS_SET_ROOT_TAXON_CHILDREN = 'TAXONS_SET_ROOT_TAXON_CHILDREN';

export const TAXONS_SET_TAXON = 'TAXONS_SET_TAXON';
export const TAXONS_SET_CHILDREN = 'TAXONS_SET_CHILDREN';
export const TAXONS_SET_PRODUCTS = 'TAXONS_SET_PRODUCTS';
export const TAXONS_SET_SHOWCASE = 'TAXONS_SET_SHOWCASE';

const initialState = {
  root: {
    taxon: undefined,
    children: undefined,
  },
  taxon: {},
  children: {},
  products: {
    all: {},
    limited: {},
    popular: {},
  },
  showcase: {},
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case TAXONS_SET_ROOT_TAXON:
      return {
        ...state,
        root: {
          ...state.root,
          taxon: payload,
        },
      };
    case TAXONS_SET_ROOT_TAXON_CHILDREN:
      return {
        ...state,
        root: {
          ...state.root,
          children: payload,
        },
      };
    case TAXONS_SET_TAXON:
      return {
        ...state,
        taxon: {
          ...state.taxon,
          [payload.slug]: payload.taxon,
        },
      };
    case TAXONS_SET_CHILDREN:
      return {
        ...state,
        children: {
          ...state.children,
          [payload.slug]: payload.children,
        },
      };
    case TAXONS_SET_PRODUCTS:
      return {
        ...state,
        products: {
          ...state.products,
          [payload.type]: {
            ...state.products[payload.type],
            [payload.slug]: payload.items,
          },
        },
      };
    case TAXONS_SET_SHOWCASE:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          [payload.slug]: payload.showcase,
        },
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function setTaxon(slug, taxon) {
  return {type: TAXONS_SET_TAXON, payload: {slug, taxon}}
}

export function setTaxonChildren(slug, children) {
  return {type: TAXONS_SET_CHILDREN, payload: {slug, children}};
}

export function fetchRootTaxon() {
  return dispatch => {
    dispatch({type: TAXONS_SET_ROOT_TAXON, payload: null});

    return dispatch(api.get(`taxons/by-code/${process.env.ROOT_TAXON}`))
      .then(rootResponse => dispatch({type: TAXONS_SET_ROOT_TAXON, payload: rootResponse.content}));
  }
}

export function fetchRootTaxonChildren() {
  return dispatch => {
    dispatch({type: TAXONS_SET_ROOT_TAXON_CHILDREN, payload: null});

    return dispatch(api.getAll(`taxons/by-code/${process.env.ROOT_TAXON}/children`, {'max-depth': 1}))
      .then(rootChildrenResponse => dispatch({
        type: TAXONS_SET_ROOT_TAXON_CHILDREN,
        payload: rootChildrenResponse.content.items,
      }));
  }
}

export function fetchTaxonBySlug(slug) {
  return dispatch => {
    dispatch(setTaxon(slug, null));

    return dispatch(api.get(`taxons/by-slug/${slug}`))
      .then(taxonResponse => {
        dispatch(setTaxon(slug, taxonResponse.content));
        return taxonResponse.content;
      })
      .catch(err => {
        if (err.status === 404) {
          dispatch(setTaxon(slug, false));
        }

        throw err;
      });
  };
}

export function fetchTaxonChildrenBySlug(slug, depth = 2) {
  return dispatch => {
    dispatch(setTaxonChildren(slug, null));

    return dispatch(api.getAll(`taxons/by-slug/${slug}/children`, {'max-depth': depth}))
      .then(childrenResponse => {
        dispatch(setTaxonChildren(slug, childrenResponse.content.items));
        return childrenResponse.content.items;
      });
  };
}

const fetchTaxonProductsBySlugTypeMap = {
  all: '',
  limited: '/limited_offer',
  popular: '/popular/weekly',
};

export function fetchTaxonProductsBySlug(type, slug) {
  return dispatch => {
    dispatch({type: TAXONS_SET_PRODUCTS, payload: {type, slug, items: null}});

    return dispatch(api.getAll(`taxons/by-slug/${slug}/products${fetchTaxonProductsBySlugTypeMap[type]}`))
      .then(
        productsResponse => dispatch({
          type: TAXONS_SET_PRODUCTS,
          payload: {type, slug, items: productsResponse.content.items},
        }),
        productsError => {
          dispatch({
            type: TAXONS_SET_PRODUCTS,
            payload: {type, slug, items: false},
          });

          throw productsError;
        },
      );
  };
}

const showcaseEventTaxonSlug = 'raids';
const showcaseProductTaxonSlug = 'dungeons';

export function fetchTaxonShowcase(slug) {
  return dispatch => {
    dispatch({type: TAXONS_SET_SHOWCASE, payload: {slug, showcase: null}});

    const showcaseEventPromise = dispatch(api.get(`taxons/by-slug/${slug}/${showcaseEventTaxonSlug}/products`, {limit: 1}))
      .then(showcaseEventsResponse => dispatch(api.get(`products/by-slug/${showcaseEventsResponse.content.items[0].slug}`)))
      .then(showcaseEventProductResponse => showcaseEventProductResponse.content);

    const showcaseEventOccurrencesPromise = showcaseEventPromise
      .then(event => dispatch(api.getAll('events/', {criteria: {preset: event.eventOptionPreset.id, product: event.id}})))
      .then(eventOccurrencesResponse => eventOccurrencesResponse.content.items);

    // TODO: backend {limit: 2} returns a single product
    const showcaseProductsPromise = dispatch(api.get(`taxons/by-slug/${slug}/${showcaseProductTaxonSlug}/products`, {limit: 3}))
      .then(showcaseProductsResponse => showcaseProductsResponse.content.items.slice(0, 2));

    return Promise.all([
      showcaseEventPromise,
      showcaseEventOccurrencesPromise,
      showcaseProductsPromise
    ]).then(
      ([event, eventOccurrences, products]) => dispatch({type: TAXONS_SET_SHOWCASE, payload: {slug, showcase: {event, eventOccurrences, products}}}),
      err => dispatch({type: TAXONS_SET_SHOWCASE, payload: {slug, showcase: false}})
    );
  }
}



// WEBPACK FOOTER //
// ./ducks/taxons.js